import script from "./FormUndanitas.vue?vue&type=script&setup=true&lang=js"
export * from "./FormUndanitas.vue?vue&type=script&setup=true&lang=js"

import "./FormUndanitas.vue?vue&type=style&index=0&id=37276565&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37276565"]])

export default __exports__